export const INSTANCE_PATH = 'merchants';

export enum RESPONSE_ERROR {
    DUPLICATED_ID = 'DUPLICATED_ID',
    DUPLICATED_NAME = 'DUPLICATED_NAME',
}

export const AUTH_PUBLIC_KEY_FIELD_NAME = 'publicKey';

export enum MERCHANT_AUTH_KEY_PAIR_ALGORITHM {
    EC = 'EC',
    RSA = 'RSA',
}
